import { useBackofficeLoggedInUser } from '@backoffice-frontend/user-management-ui'
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'

export const useSentryUserContext = () => {
  const { user, loading } = useBackofficeLoggedInUser()

  useEffect(() => {
    if (!loading && user?.userType) {
      Sentry.setTag('user_type', user.userType)
    }
  }, [user?.userType, loading])
}
